



































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { baseUrl } from '@/config.json'
import { getToken } from '@/utils/cookies'
@Component({
  name: 'UploadImage'
})
export default class extends Vue {
  @Prop({ default: '.jpg,.jpeg,.png' }) type: string
  @Prop({ default: 2 }) size: number
  @Prop({ default: '' }) propImageUrl: string
  @Prop({ default: false }) enable1k: boolean

  private headers = {
    token: getToken()
  }
  private imageUrl = ''
  handleRemove() {}

  @Watch('propImageUrl')
  private onChange(val) {
    this.imageUrl = val
  }

  handleError(err, file, fileList) {
    console.log(err, file, fileList, 'handleError')
    this.$message({
      message: '图片上传失败',
      type: 'error'
    })
  }

  handleAvatarSuccess(response: any, file: any, fileList: any) {
    // this.imageUrl = response.data
    // this.imageUrl = `http://172.17.2.120:8080/common/download?name=${response.data}`
    this.imageUrl = `${response.data}`
    // this.imageUrl = `${baseUrl}/common/download?name=${response.data}`

    this.$emit('imageChange', this.imageUrl)
  }

  oploadImgDel() {
    this.imageUrl = ''
    this.$emit('imageChange', this.imageUrl)
  }
  async beforeAvatarUpload(file) {
    const isLt2M = file.size / 1024 / 1024 < this.size
    if (!isLt2M) {
      this.$message({
        message: `上传文件大小不能超过${this.size}M!`,
        type: 'error'
      })
      return false
    }
    if (this.enable1k) {
      try {
        const resized = await this.resizeTo1K(file)
        return resized || file
      } catch (e) {
        console.error('图片重采样失败，使用原图上传:', e)
        return file
      }
    }
  }

  // 通过 canvas 重采样：最长边不超过 1280px（仅缩小，不放大；保持纵横比；输出格式与源图相同）
  resizeTo1K(file): Promise<File | null> {
    return new Promise((resolve, reject) => {
      if (!/^image\/(png|jpeg)$/.test(file.type)) {
        resolve(null)
        return
      }
      const reader = new FileReader()
      reader.onload = (e: any) => {
        const img = new Image()
        img.onload = () => {
          const target = 1280
          const maxSide = Math.max(img.width, img.height)
          if (maxSide <= target) {
            // 小图不放大，保持原样，避免无损放大导致 PNG 体积暴涨、触发上传限制
            resolve(null)
            return
          }
          const scale = target / maxSide
          const w = Math.round(img.width * scale)
          const h = Math.round(img.height * scale)
          const canvas = document.createElement('canvas')
          canvas.width = w
          canvas.height = h
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, w, h)
          const mime = file.type === 'image/png' ? 'image/png' : 'image/jpeg'
          canvas.toBlob((blob) => {
            if (!blob) {
              reject(new Error('canvas.toBlob 生成失败'))
              return
            }
            resolve(new File([blob], file.name, { type: mime }))
          }, mime)
        }
        img.onerror = () => reject(new Error('图片加载失败'))
        img.src = e.target.result
      }
      reader.onerror = () => reject(new Error('文件读取失败'))
      reader.readAsDataURL(file)
    })
  }
}
